import React from "react";
import Icon from "../ui/Icon";

/* local copy for now (we'll move to utils later without behavior change) */
const AVATAR_GRADIENTS = [
  ["#4ADE80", "#16A34A"],
  ["#38BDF8", "#0284C7"],
  ["#FCD34D", "#D97706"],
  ["#C084FC", "#7C3AED"],
  ["#FB7185", "#BE123C"],
  ["#FB923C", "#C2410C"],
  ["#34D399", "#059669"],
  ["#A78BFA", "#5B21B6"],
];

const getAvatarColors = (name = "") => {
  if (!name || typeof name !== "string") return AVATAR_GRADIENTS[0];
  return AVATAR_GRADIENTS[name.charCodeAt(0) % AVATAR_GRADIENTS.length];
};

export default function ParticipantsModal({ open, onClose, list }) {
  if (!open) return null;

  return (
    <div
      className="jt-modalOverlay"
      role="dialog"
      aria-modal="true"
      onMouseDown={onClose}
    >
      <div className="jt-sheet" onMouseDown={(e) => e.stopPropagation()}>
        <div className="jt-sheetHead">
          <div className="jt-sheetTitle">
            <span className="jt-sheetIcon">
              <Icon name="people" />
            </span>
            Participants ({list.length})
          </div>
          <button
            className="jt-sheetClose"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon name="close" />
          </button>
        </div>

        <div className="jt-sheetBody">
          {list.map((p) => {
            const [c1, c2] = getAvatarColors(p.name);
            const roleLabel =
              p.role === "host"
                ? "Host"
                : p.role === "speaker"
                  ? "Speaker"
                  : null;
            const roleColor =
              p.role === "host"
                ? "var(--jt-gold)"
                : p.role === "speaker"
                  ? "var(--jt-purple)"
                  : "var(--jt-accent)";

            return (
              <div key={p.id} className="jt-partRow">
                <div
                  className="jt-partAvatar"
                  style={{
                    background: `linear-gradient(135deg, ${c1}, ${c2})`,
                  }}
                >
                  {p.image ? (
                    <img src={p.image} alt="" />
                  ) : (
                    <span>{(p.name?.[0] || "?").toUpperCase()}</span>
                  )}
                  {p.isLive && <i className="jt-onlineDot" />}
                </div>

                <div className="jt-partInfo">
                  <div className="jt-partName" title={p.name}>
                    {p.isLocal ? `${p.name} (You)` : p.name}
                  </div>
                  {roleLabel && (
                    <div
                      className="jt-rolePill"
                      style={{ borderColor: roleColor, color: roleColor }}
                    >
                      {roleLabel}
                    </div>
                  )}
                </div>

                <div className="jt-partStatus">
                  {p.isMuted && (
                    <span className="jt-statusChip off" title="Mic off">
                      <Icon name="micOff" />
                    </span>
                  )}
                  {!p.isMuted && p.isLive && (
                    <span className="jt-statusChip on" title="Mic on">
                      <Icon name="mic" />
                    </span>
                  )}
                  {p.isCameraOff && (
                    <span className="jt-statusChip off" title="Camera off">
                      <Icon name="camOff" />
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
